export enum MeasurementModeEnum {
  Direct = 0,
  Derived = 1
}
